module.exports = __webpack_public_path__ + "img/CV.Utilities.Chambers.Stakka_Modula_Chamber.2565f452.png";